import React from "react"

class Thumbnail extends React.Component{
    placeHolderImg = (e) =>{
        e.target.src = "/placeHolder.png"
    }
    render(){
        return(
            <div className="thumbnail">
                <div className="imgWrapper">
                    <img onError={this.placeHolderImg} className="gameThumbnail" alt={this.props.gameName} src={this.props.imgUrl}/>
                </div>
            </div>
        )
    }
}

export default Thumbnail